import type { ReactNode } from "react";

import { cx } from "./cx";
import styles from "./EmptyState.module.css";

export type EmptyStateTone = "neutral" | "error";

export interface EmptyStateProps {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  tone?: EmptyStateTone;
  className?: string;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  tone = "neutral",
  className,
}: EmptyStateProps): JSX.Element {
  return (
    <div className={cx(styles.empty, className)}>
      {icon && (
        <div className={cx(styles.icon, tone === "error" && styles.error)} aria-hidden="true">
          {icon}
        </div>
      )}
      <div className={styles.title}>{title}</div>
      {description && <div className={styles.description}>{description}</div>}
      {action && <div className={styles.action}>{action}</div>}
    </div>
  );
}
